import React, { memo, useCallback } from 'react';
import { Element } from 'src/components';
import { AdBanner } from 'src/modules/shared/components/ad';

interface IProps {
    adMasthead: any;
}

export function AdMasthead({ adMasthead = {} }: IProps) {
    const renderAds = useCallback(() => {
        return (
            <Element id="js-masthead">
                {adMasthead.zoneAdaptive && (
                    <AdBanner
                        elId={adMasthead.elId || ''}
                        classNameContainer={'masthead-wrapper'}
                        zoneAdaptive={adMasthead.zoneAdaptive}
                    />
                )}
            </Element>
        );
    }, [adMasthead]);

    return <>{renderAds()}</>;
}

export default memo(AdMasthead);
